import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import DataStore from '../../core/stores/DataStore';
import AppStore from '../stores/AppStore';

interface StoresProviderProps {
  children: ReactNode;
  dataStore: DataStore;
  appStore: AppStore;
}

const StoresContext = createContext({
  dataStore: new DataStore(),
  appStore: new AppStore(),
});

/* Hooks to use stores in any functional component */
export const useDataStore = () => useContext(StoresContext).dataStore;
export const useAppStore = () => useContext(StoresContext).appStore;

const StoresProvider = ({ children, dataStore, appStore }: StoresProviderProps) => {
  const stores = useMemo(
    () => ({
      dataStore,
      appStore,
    }),
    [dataStore, appStore]
  );

  return <StoresContext.Provider value={stores}>{children}</StoresContext.Provider>;
};

export default StoresProvider;
